import Image from "next/image";
import Link from "rivals/components/shared/Link";
import commonStrings from "rivals/shared/strings/common";
import style from "./Publisher.module.scss";
import { Props } from "./types";

const DATA_PHILTER = "publisher-ad";
const PUBLISHER_AD_HEIGHT = 250;
const PUBLISHER_AD_WIDTH = 300;

export default function PublisherAd({
  href,
  imageUrl
}: Props): React.JSX.Element | null {
  if (!href || !imageUrl) {
    return null;
  }

  const { advertisement } = commonStrings;

  return (
    <Link
      className={style.container}
      data={DATA_PHILTER}
      href={href}
      target="_blank"
    >
      <Image
        alt={advertisement}
        fill={false}
        height={PUBLISHER_AD_HEIGHT}
        src={imageUrl}
        style={{ objectFit: "contain" }}
        width={PUBLISHER_AD_WIDTH}
      />
    </Link>
  );
}
